import {
  React,
  useEffect,
  useState,
  TextField,
  Autocomplete,
  createFilterOptions,
  CircularProgress,
  AddIcon,
  axiosInstance,            // ✅ use your axiosInstance
} from "../utils/commonImports";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InputAdornment from "@mui/material/InputAdornment";

const filter = createFilterOptions();

function CategoryDropdown({
  clientId,
  categoryType = "Designation",
  name,
  value,
  onChange,
  onKeyDown,
  label = "Designation",
  size = "small",
}) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch from backend (with client_id)
  useEffect(() => {
    
    let active = true;
    setLoading(true);

    axiosInstance
      .get("/api/components/category", {
        params: { type: categoryType, client_id: clientId },
      })
      
      .then((res) => {
        console.log("API response for category options:", res.data);
        if (active) setOptions(res.data || []);
      })
      .catch(() => {
               if (active) setOptions([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [categoryType, clientId]);

  // Add new to backend and refresh
  const handleAddNew = async (newName) => {
    setLoading(true);
    await axiosInstance.post("/api/components/category", {
      categorytype: categoryType,
      categoryname: newName,
      client_id: clientId,
    });

    const res = await axiosInstance.get("/api/components/category", {
      params: { type: categoryType, client_id: clientId },
    });
    setOptions(res.data || []);

    if (onChange) {
      onChange({
        target: { name, value: newName, label: newName },
      });
    }
    setLoading(false);
  };

  // filter + "Add new" option
  const filterOptions = (opts, params) => {
    const filtered = filter(opts, params);
    const exists = opts.some(
      (opt) =>
        typeof opt.categoryname === "string" &&
        opt.categoryname.trim().toLowerCase() ===
          (params.inputValue || "").trim().toLowerCase()
    );
    if (params.inputValue && !exists) {
      filtered.push({
        inputValue: params.inputValue,
        categoryname: params.inputValue,
        isAddNew: true,
      });
    }
    return filtered;
  };

  const handleSelect = (event, newValue) => {
    if (newValue && newValue.isAddNew) {
      handleAddNew(newValue.categoryname);
    } else if (onChange) {
      onChange({
        target: {
          name,
          value: newValue ? newValue.categoryid : "",
          label: newValue ? newValue.categoryname : "",
        },
      });
    }
  };

  const getOptionLabel = (option) => {
console.log("Vehicle group options:", options);
    if (typeof option === "string") return option;
    if (option.inputValue) return option.inputValue;
    return option.categoryname || "";
  };



  const renderOption = (props, option) => {
    
    const { key, ...restProps } = props;
    if (option.isAddNew) {
      return (
        <li key={key} {...restProps}>
          <AddIcon style={{ marginRight: 8, color: "#0d47a1" }} />
          <span>
            <b>Add New {categoryType}: </b>
            {option.categoryname}
          </span>
        </li>
      );
    }
    return (
      <li key={key} {...restProps} style={{ display: "block", padding: 8 }}>
        <div style={{ fontWeight: 500, fontSize: 15, color: "#111" }}>
          {option.categoryname}
        </div>
        <div
          style={{
            fontSize: 13,
            color: "#777",
            marginTop: 2,
            lineHeight: 1.25,
            wordBreak: "break-word",
          }}
        >
          {option.description}
        </div>
      </li>
    );
  };

  // // ✅ Prefer match by ID; fallback to name for backward compatibility
  // const selectedOption =
  //   options.find((o) => String(o.categoryid) === String(value)) ||
  //   options.find((o) => o.categoryname === value) ||
  //   null;

  const selectedOption =
  value && value !== ""
    ? options.find((o) => String(o.categoryid) === String(value)) ||
      options.find((o) => o.categoryname === value) ||
      null
    : null;

  return (
    <Autocomplete
    
      value={selectedOption}
      onChange={handleSelect}
      filterOptions={filterOptions}
      options={options}
      getOptionLabel={getOptionLabel}
      loading={loading}
      isOptionEqualToValue={(opt, val) => opt.categoryid === val.categoryid}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={`Select or add a ${categoryType}`}
          size={size}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
                <InputAdornment position="end">
                  <ArrowDropDownIcon />
                </InputAdornment>
              </>
            ),
          }}
          onKeyDown={onKeyDown}
        />
      )}
      renderOption={renderOption}
      selectOnFocus
      clearOnBlur={true}
      handleHomeEndKeys
      fullWidth
      freeSolo
    />
  );
}

export default CategoryDropdown;
